module.exports = __webpack_public_path__ + "static/media/epbf-logo.343249ad.svg";